/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Kanban_Db_Ref_ErrorInputs */

const en_explorer_kanban_db_ref_error = /** @type {(inputs: Explorer_Kanban_Db_Ref_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Database reference not available`)
};

const fr_explorer_kanban_db_ref_error = /** @type {(inputs: Explorer_Kanban_Db_Ref_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reference de base de donnees non disponible`)
};

const de_explorer_kanban_db_ref_error = /** @type {(inputs: Explorer_Kanban_Db_Ref_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datenbankreferenz nicht verfügbar`)
};

const it_explorer_kanban_db_ref_error = /** @type {(inputs: Explorer_Kanban_Db_Ref_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riferimento al database non disponibile`)
};

const ru_explorer_kanban_db_ref_error = /** @type {(inputs: Explorer_Kanban_Db_Ref_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ссылка на базу данных недоступна.`)
};

const es_explorer_kanban_db_ref_error = /** @type {(inputs: Explorer_Kanban_Db_Ref_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Referencia de base de datos no disponible`)
};

const zh_cn2_explorer_kanban_db_ref_error = /** @type {(inputs: Explorer_Kanban_Db_Ref_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数据库引用不可用`)
};

const ja_explorer_kanban_db_ref_error = /** @type {(inputs: Explorer_Kanban_Db_Ref_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`データベース参照が利用できません`)
};

const hi_explorer_kanban_db_ref_error = /** @type {(inputs: Explorer_Kanban_Db_Ref_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`डेटाबेस संदर्भ उपलब्ध नहीं है`)
};

const pt_pt2_explorer_kanban_db_ref_error = /** @type {(inputs: Explorer_Kanban_Db_Ref_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Referência de banco de dados não disponível`)
};

/**
* | output |
* | --- |
* | "Database reference not available" |
*
* @param {Explorer_Kanban_Db_Ref_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_kanban_db_ref_error = /** @type {((inputs?: Explorer_Kanban_Db_Ref_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Kanban_Db_Ref_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_kanban_db_ref_error(inputs)
	if (locale === "de") return de_explorer_kanban_db_ref_error(inputs)
	if (locale === "it") return it_explorer_kanban_db_ref_error(inputs)
	if (locale === "ru") return ru_explorer_kanban_db_ref_error(inputs)
	if (locale === "es") return es_explorer_kanban_db_ref_error(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_kanban_db_ref_error(inputs)
	if (locale === "ja") return ja_explorer_kanban_db_ref_error(inputs)
	if (locale === "hi") return hi_explorer_kanban_db_ref_error(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_kanban_db_ref_error(inputs)
	return en_explorer_kanban_db_ref_error(inputs)
});